<script>
	import Bundle from '../../Classes/Editor/Bundle';
	import Color from '../../Classes/Editor/Color';
	import Helper from '../../Classes/Helper';
	import Info from '../../Classes/Editor/Info';
	import Input from '../../Classes/Editor/Input';
	import Next from '../../Stores/Next';
	import Note from '../../Components/Widgets/Note.svelte';
	import Product from '../../Stores/Product';
	import Registry from '../../Stores/Registry';
	import Upgrade from '../../Classes/Editor/Upgrade';
	import Upsell from '../../Classes/Editor/Upsell';
	import Widget from '../../Stores/Widget';
	import {tick} from 'svelte';

	let list = [];
	let building = false;

	async function build() {
		building = true;
		list = [];
		await tick();

		const group = $Product.property.group;
		if (group) {
			for (let property of $Product.step.properties)
				if (property.group === group) {
					const active = $Product.property == property;
					await buildList(property, active);
				}
		}
		else await buildList($Product.property, true);

		building = false;
	}

	async function buildList(property, active) {
		let builder;
		switch ($Product.step.step_group) {
			case 'Kleur': builder = Color; break;
			default:
				switch (property.property_type) {
					case 'options': builder = Input; break;
					case 'infos': builder = Info; break;
					case 'upgrades': builder = Upgrade; break;
					case 'upsells': builder = Upsell; break;
					case 'bundles': builder = Bundle; break;
				}
			break;
		}

		if (builder) {
			$Registry.configurator_renderer = builder === Color;
			builder = new builder();
			list = builder.build(list, property, !!active);
			await tick(); /* Wait for the render to finish. */
		}
	}

	function description(content) {
		const pattern = /\ssrc="\/storage\//ig;
		const replacement = ' src="https://shop.zonenscherm.nl/e2/zonscherm/site/custom/';
		return content.replace(pattern, replacement);
	}

	function next() {
		Next.setCancel();
		Product.setNext();
	}

	Product.subscribe(data => {
		if (Helper.is(data))
			if (!building && !$Product.step.description_active)
				build();
	});
</script>

<style>
	div.zes-next {
		margin-bottom: 1.5em;
	}

	div.zes-property-groups {
		padding-bottom: 1.25em;
		gap: .5em;
		grid-template-columns: 1fr 1fr;
		display: none;
	}

	div.zes-property-groups > div {
		font-size: .95em;
		font-weight: 600;
		padding: .5em 1em;
		color: var(--zes-1-1);
		border-radius: .35em;
		background: var(--zes-1-4);
	}

	div.zes-property-groups > div.zes-active {
		color: #FFF;
		background: var(--zes-1-2);
	}

	/* Description */

	:global(div.zes-container-editor-layout-box > div.zes-property-description p) {
		line-height: 1.5em;
		margin: 1em 0;
	}

	:global(div.zes-container-editor-layout-box > div.zes-property-description p:first-child),
	:global(div.zes-container-editor-layout-box > div.zes-property-description p:first-child strong) {
		border-top: none;
		padding-top: 0;
		margin-top: 0;
	}

	:global(div.zes-container-editor-layout-box > div.zes-property-description p:empty),
	:global(div.zes-container-editor-layout-box > div.zes-property-description strong:empty) {
		display: none;
	}

	:global(div.zes-container-editor-layout-box > div.zes-property-description strong) {
		display: block;
		font-weight: 600;
		color: var(--zes-1-2);
		padding-top: 1.5em;
		margin-top: 1em;
		border-top: 2px solid var(--zes-1-4);
	}

	:global(div.zes-container-editor-layout-box > div.zes-property-description a) {
		font-weight: 600;
		color: var(--zes-1-2);
	}

	/* Button */

	div.zes-button {
		font-size: .65em;
		font-weight: 600;
		text-align: center;
		text-transform: uppercase;
		color: #FFF;
		padding: .5em 1.5em;
		border-radius: .35em;
		background: var(--zes-1-2);
		cursor: pointer;
	}

	div.zes-button.zes-success {
		font-size: 1.25em;
		background: var(--zes-2-2);
	}

	div.zes-button i {
		margin-left: .5em;
	}

	div.zes-button.zes-success:hover {
		background: var(--zes-2-1);
	}

	/* Responsive */

	@media only screen and (max-width: 1024px) and (orientation: portrait) {
		div.zes-property-groups {
			display: grid;
		}

		div.zes-next {
			display: none;
		}
	}
</style>

{#if $Product.property}
	{#if !$Product.step.description_active}
		<div class="zes-next">
			<div class="zes-button zes-success" on:click="{event => next()}">
				Volgende <i class="fa-solid fa-circle-chevron-right"></i>
			</div>
		</div>
		{#if $Product.step.notice}
			<Note config="{{title: $Product.step.notice, icon: 'fa-regular fa-circle-exclamation'}}"/>
		{/if}
		{#if $Product.property.groups}
			<div class="zes-property-groups">
				{#each $Product.property.groups as group, counter}
					{#if Product.menuVisibleGroup($Product.property, group)}
						<div on:click="{event => Product.setGroup(group)}" class:zes-active="{group.active}">{group.name}</div>
					{/if}
				{/each}
			</div>
		{/if}
		{#each list as element}
			<svelte:component this="{element.component}" config="{element.config}"/>
		{/each}
	{:else}
		<div class="zes-property-description">
			{@html description($Product.step.description)}
			{@html description($Product.step.description_right)}
		</div>
	{/if}
{/if}